// NOTE: the folder is `coverage-dashboard`, NOT `coverage` — .gitignore's unanchored `coverage/`
// pattern would both untrack the folder AND make Tailwind's source scanner skip its classes.
import { CoverageDashboard } from './coverage-dashboard/CoverageDashboard'

import type { GisOverview, GisScope } from '../../api/types'

interface CoverageTabContentProps {
  overview: GisOverview
  scope: GisScope
  activeMandals: readonly string[]
  onSelectSite: (id: string) => void
}

/**
 * District **Coverage** lens (V5 toolbar layout). The list IS the tab: search / Status / Officer /
 * Mandal filters + Group + the Sites|Officers|Surveys switch live in the page-level
 * `CoverageToolbar` (GisViewPage); the old Explore Coverage / Survey Status cards were folded into
 * it (git history has them). The mandal page-filter (`activeMandals`) re-scopes everything.
 */
export function CoverageTabContent({ overview, scope, activeMandals, onSelectSite }: CoverageTabContentProps) {
  return <CoverageDashboard overview={overview} scope={scope} activeMandals={activeMandals} onSelectSite={onSelectSite} />
}
